import {
  KnowMeTypography,
  KnowMeTypographyOverrides,
  typography,
} from '@/config/theme/typography.ts';
/* eslint-disable @typescript-eslint/no-empty-object-type */
import { createTheme } from '@mui/material/styles';

import { components } from './components.ts';
import { themeColors } from './themeColors.ts';
import { variables } from './variables.ts';

declare module '@mui/material/styles' {
  interface Theme {
    colors: typeof themeColors;
    variables: typeof variables;
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    colors: Partial<typeof themeColors>;
    variables: Partial<typeof variables>;
  }
}

declare module '@mui/material/styles' {
  interface TypographyVariants extends KnowMeTypography {}

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions extends Partial<KnowMeTypography> {}
}

declare module '@mui/material/Typography' {
  interface TypographyPropsColorOverrides {
    white: true;
  }

  interface TypographyPropsVariantOverrides extends KnowMeTypographyOverrides {}
}

declare module '@mui/material/IconButton' {
  interface IconButtonOwnProps {
    variant?: 'contained' | 'ghost' | 'outlined';
  }
}

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    blue: true;
    darkBlue: true;
    gray: true;
    lightGreen: true;
    lightOrange: true;
    orange: true;
    red: true;
    yellow: true;
  }
}
declare module '@mui/material/TableRow' {
  interface TableRowOwnProps {
    clickable?: string;
  }
}
declare module '@mui/material/TableCell' {
  interface TableCellPropsSizeOverrides {
    large: true;
  }
}

const getSpacing = (factor?: number) => {
  if (factor === undefined || factor < 1) {
    return 0;
  }
  return [0, 4, 8, 12, 16, 24, 32, 40][factor];
};

export const knowMeTheme = createTheme({
  colors: themeColors,
  components,
  palette: {
    grey: {
      100: themeColors.gray_10,
      200: themeColors.gray_12,
      300: themeColors.gray_30,
    },
    primary: {
      ...themeColors,
      main: themeColors.blue,
    },
    secondary: {
      ...themeColors,
      main: themeColors.darkBlue,
    },
    warning: {
      main: themeColors.orange,
    },
  },
  spacing: getSpacing,
  typography,
  variables,
});
